import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const logoClassName = "dibl1p95mcm";
const SystimeLogoLarge = ({
  color,
  preserveAspectRatio,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    ...svgProps,
    className: logoClassName,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 283.5 70.3",
    preserveAspectRatio: preserveAspectRatio ?? "xMinYMid",
    fill: color,
    children: [/*#__PURE__*/jsx("path", {
      d: "m266.2 44-17.2-9.9v19.9l17.2-10-17.2-9.9v19.9z",
      fill: "#216071"
    }), /*#__PURE__*/jsx("path", {
      d: "m283.5 34.1-17.3-10v19.9l17.3-9.9-17.3-10v19.9z",
      fill: "#dc0a2f"
    }), /*#__PURE__*/jsx("path", {
      d: "m266.2 24.1-17.2-10v20l17.2-10-17.2-10v20z",
      fill: "#6eaeb4"
    }), /*#__PURE__*/jsx("path", {
      d: "m249 34.1 17.2 9.9v-19.9l-17.2 10 17.2 9.9v-19.9z",
      fill: "#771612"
    }), /*#__PURE__*/jsx("path", {
      d: "m26.8 19.8s-8.1-1.2-13.2-1.2c-4.7 0-9 1.3-9 6.5 0 4 1.9 5.1 10.2 6.5 9.7 1.6 13.4 3.3 13.4 10.6 0 8.9-5.5 11.8-14.7 11.8-4.6 0-13-1.4-13-1.4l.3-4s8.5 1.3 12.4 1.3c6.5 0 10.3-1.5 10.3-7.4 0-4.6-2.3-5.5-10.8-6.8-8.7-1.5-12.7-3.1-12.7-10.5 0-8.2 6.8-10.7 13.5-10.7 5.7 0 13.5 1.3 13.5 1.3zm9.5-4.6 10.1 34.1h2.7l10.2-34.1h4.7l-16.4 55.1h-4.6l5.1-17.1h-5.2l-11.2-38zm58 4.6s-8.1-1.2-13.2-1.2c-4.7 0-9 1.3-9 6.5 0 4 1.9 5.1 10.2 6.5 9.7 1.6 13.4 3.3 13.4 10.6 0 8.9-5.5 11.8-14.7 11.8-4.6 0-13-1.4-13-1.4l.3-4s8.5 1.3 12.4 1.3c6.5 0 10.3-1.5 10.3-7.4 0-4.6-2.3-5.5-10.8-6.8-8.7-1.4-12.8-3-12.8-10.3 0-8.3 6.8-10.7 13.5-10.7 5.7 0 13.5 1.3 13.5 1.3zm15.7-.6v18.8c0 9.5.6 11.9 6.1 11.9 2.1 0 7-.5 7-.5l.3 3.9s-5 .8-7.7.8c-7.5 0-10.3-2.8-10.3-13.8v-21.1h-5.6v-4h5.6v-11.9h4.6v11.9h12.7v4zm18.3-19.2h4.5v5.7h-4.5zm0 15.2h4.5v38h-4.5zm14.4 38v-38h4.5v2.8s5.8-3.6 11.6-3.6c5.2 0 8.1 1.2 10 4 0 0 6.7-4 13.7-4 10.3 0 12.7 4.7 12.7 18.8v20h-4.5v-19.8c0-11.2-1.2-14.9-8.7-14.9-6.2 0-11.6 3.2-11.6 3.2.8 2.1 1.1 6.7 1.1 11.7v19.8h-4.6v-19.6c0-11.4-1.2-15.1-8.7-15.1-5.9 0-11.1 3.2-11.1 3.2v31.5zm89.4-4 .2 3.7s-8.6 1.1-14.5 1.1c-11.3-.1-14.7-6.9-14.7-19.6 0-14.7 6.4-19.9 15.7-19.9 9.8 0 15 5.2 15 18l-.2 3.6h-25.8c0 9 2.6 13.8 10.6 13.8 5.3 0 13.7-.7 13.7-.7zm-3.1-16.9c0-10.3-3.3-13.9-10.4-13.9-6.9 0-11 3.8-11 13.9z"
    })]
  });
};
const SystimeLogoSmall = ({
  color,
  preserveAspectRatio,
  disableDefaultClassName,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    ...svgProps,
    className: !disableDefaultClassName ? logoClassName : undefined,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.5 39.9",
    preserveAspectRatio: preserveAspectRatio,
    fill: color,
    children: [/*#__PURE__*/jsx("path", {
      d: "m17.2 29.9-17.2-9.9v19.9l17.2-10-17.2-9.9v19.9z",
      fill: "#216071"
    }), /*#__PURE__*/jsx("path", {
      d: "m34.5 20-17.3-10v19.9l17.3-9.9-17.3-10v19.9z",
      fill: "#dc0a2f"
    }), /*#__PURE__*/jsx("path", {
      d: "m17.2 10-17.2-10v20l17.2-10-17.2-10v20z",
      fill: "#6eaeb4"
    }), /*#__PURE__*/jsx("path", {
      d: "m0 20 17.2 9.9v-19.9l-17.2 10 17.2 9.9v-19.9z",
      fill: "#771612"
    })]
  });
};

export { SystimeLogoLarge, SystimeLogoSmall };
import "./Systime.linaria.module.css";
//# sourceMappingURL=Systime.js.map
